import type React from "react"

export const Book: React.FC<React.SVGAttributes<SVGSVGElement>> = (props) => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Book</title>
    <path d="M14 11V1.5C14 0.6875 13.3125 0 12.5 0H2.5C1.09375 0 0 1.125 0 2.5V13.5C0 14.9062 1.09375 16 2.5 16H13.25C13.6562 16 14 15.6875 14 15.25C14 14.8438 13.6562 14.5 13.25 14.5H13V12.4375C13.5625 12.2188 14 11.6562 14 11ZM11.5 14.5H2.5C1.9375 14.5 1.5 14.0625 1.5 13.5C1.5 12.9688 1.9375 12.5 2.5 12.5H11.5V14.5ZM12.5 11H2.5C2.125 11 1.78125 11.0938 1.5 11.2188V2.5C1.5 1.96875 1.9375 1.5 2.5 1.5H12.5V11ZM4.75 5H10.25C10.6562 5 11 4.6875 11 4.25C11 3.84375 10.6562 3.5 10.25 3.5H4.75C4.3125 3.5 4 3.84375 4 4.25C4 4.6875 4.3125 5 4.75 5ZM4.75 7.5H10.25C10.6562 7.5 11 7.1875 11 6.75C11 6.34375 10.6562 6 10.25 6H4.75C4.3125 6 4 6.34375 4 6.75C4 7.1875 4.3125 7.5 4.75 7.5Z" />
  </svg>
)
